import { render, staticRenderFns } from "./ListComment.vue?vue&type=template&id=dd640918&"
import script from "./ListComment.vue?vue&type=script&lang=js&"
export * from "./ListComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports